import { opinions } from '../defaults/opinions';

export const lachs = {
	name: 'Lachsfilet',
	desc: 'Ein scharf angebratenes Lachsfilet. Außen knusprig, innen saftig. Als Portion mit Salat und einer Zitronenscheibe.',
	image: 2,
	benefits: [
		'Sehr viele Proteine',
		'Gesundes Omega3 Fett',
		'Wenig gesättigte Fettsäuren',
	],
	opinions: [
		{
			name: 'Jane Doe',
			date: '14. Januar 2017',
			title: 'Sehr lecker',
			content: 'Sehr lecker und frisch',
			rating: 3,
		},
		...opinions,
	],
	recommandation: 'Als Nachtisch villeicht etwas Müsli, das die fehlenden Ballaststoffe liefert.',
	warnings: ['fisch', 'alkohol'],
	ingredients: [
		{'Lachsfilet': 'fisch'},
		'Zwiebeln',
		{'Weißwein': 'alkohol'},
		{'Sahne': 'laktose'},
		'Curry',
		'Knoblauch',
		'Lorbeer',
		'Zitrone',
	],

};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/lachs.js